import * as React from 'react';
import MuiTableBody from '@mui/material/TableBody';
import MuiTableCell from '@mui/material/TableCell';
import MuiTableRow from '@mui/material/TableRow';
import _get from 'lodash/get';
import { grey } from '@mui/material/colors';
import { useTheme } from '@mui/material';
import { v4 as uuidv4 } from 'uuid';
import _ from 'lodash';

const TableBody = ({
  rows,
  columns,
  onClick = () => { },
  formatValue = () => { },
  onSelectItem = () => { },
  selected,
  handleSavePosition = () => { },
}) => {
  const theme = useTheme();
  return (
    <MuiTableBody>
      {rows.map((row) => {
        if (row.disabled) {
          return (
            <MuiTableRow
              role='checkbox'
              tabIndex={-1}
              key={uuidv4()}
              sx={{ backgroundColor: grey[300] }}
            >
              {columns.map(({ key, align, id, checkbox = false, cellSx }, j) => (
                <MuiTableCell
                  key={uuidv4()}
                  align={align}
                  sx={{
                    color: grey[600],
                    ...cellSx
                  }}
                >
                  {formatValue(
                    key,
                    _get(row, id),
                    checkbox ? null : () => onSelectItem(row)
                  )}
                </MuiTableCell>
              ))}
            </MuiTableRow>
          );
        }

        return (
          <MuiTableRow
            hover
            role='checkbox'
            tabIndex={-1}
            key={uuidv4()}
            sx={{
              '&:nth-of-type(even)': {
                backgroundColor: theme.palette.secondary.medium_20,
                '&:hover': {
                  backgroundColor: theme.palette.secondary.medium_30,
                },
              },
              '&:nth-of-type(odd)': {
                '&:hover': {
                  backgroundColor: theme.palette.secondary.medium_30,
                },
              },
              // hide last border
              '&:last-child td, &:last-child th': {
                border: 0,
              },
            }}
          >
            {columns.map(
              (
                {
                  key,
                  align,
                  id,
                  checkbox = false,
                  selectable = false,
                  display,
                  cellSx,
                },
                j
              ) => {
                const isChecked =
                  selectable &&
                  !!_.find(selected, (item) => `${item}` === `${row?.id}`);

                return (
                  <MuiTableCell
                    key={uuidv4()}
                    align={align}
                    sx={{
                      cursor: checkbox
                        ? selectable
                          ? 'pointer'
                          : 'default'
                        : 'pointer',
                      display: display,
                      ...cellSx,
                    }}
                    onClick={
                      checkbox
                        ? selectable
                          ? () => onSelectItem(row)
                          : () => handleSavePosition()
                        : () => onClick(row)
                    }
                  >
                    {formatValue(key, _get(row, id), () => { }, isChecked)}
                  </MuiTableCell>
                );
              }
            )}
          </MuiTableRow>
        );
      })}
    </MuiTableBody>
  );
};

export default TableBody;
